import React from "react";
import ReactDOM from "react-dom/client";
import "@repo/ui/styles.css";
import "customer/customer.css";
import "@/styles/index.css";
import { RouterProvider } from "react-router-dom";
import globalRouterConfig from "@/libs/React-Router-Dom/globalRouterConfig";
import { QueryClientProvider } from "@tanstack/react-query";
import queryClientGlobal from "@repo/api-services/queryConfig.ts";
import { Toaster } from "react-hot-toast";
import GlobalThemeContextProvider from "./store/context/ThemeContext";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import NetworkCheck from "./components/NetworkCheck";
import { HelmetProvider } from "react-helmet-async";
import { SecurityProvider } from "@repo/providers";
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SecurityProvider>
      <QueryClientProvider client={queryClientGlobal}>
        <HelmetProvider>
          <GlobalThemeContextProvider>
            <RouterProvider router={globalRouterConfig} />
            <Toaster position="bottom-right" />
            <NetworkCheck />
          </GlobalThemeContextProvider>
        </HelmetProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </SecurityProvider>
  </React.StrictMode>
);
